import React, { useEffect, useState } from 'react';

import Layout from '../Layout';
import SpinnerBlock from '../../components/Common/Spinner/Spinner';
import es from '../../lang/es';
import routes from '../../constants/routes';
import { faFileInvoiceDollar, faMoneyCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router';
import { Alert, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import api from '../../helpers/api';
import apiMethods from '../../constants/apiMethods';
import alertMessages from '../../helpers/alertMessages';
import OnlineForm from '../../components/Checkout/OnlineForm';

const CheckoutOnline = () => {
    //Navigator
    let navigate = useNavigate();
    //Tomo params
    const { id } = useParams();
    //State local
    const [loading, setLoading] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    //Actions
    const actions = [
        {
            title: es.ACTIONS.NEW,
            type: 'success',
            icon: faFileInvoiceDollar,
            visible: true,
            handle: () => {
                navigate(routes.PAYMENT_CREATE)
            }
        },
        {
            title: es.CLOSE.toUpperCase(),
            type: 'danger',
            icon: faTimes,
            visible: true,
            handle: () => {
                navigate(routes.PAYMENT_CHECKOUT)
            }
        }
    ];
    //Inicio
    useEffect(() => {
        handleLoadData();
    }, []);
    //Manejo la carga de datos
    const handleLoadData = async () => {
        //Realizao la búsqueda
        try{
            //Cargo las espera
            setLoading(true);
            //Hago la consulta
            const response = await api.post(apiMethods.CHECKOUT_ONLINE(id));
            //Obtengo los datos
            const res = response.data;
            //Seteo los valores
            setPaymentData(res.data);
            //Oculta la espera
            setLoading(false);
        }catch(error){
            //Tomo respuesta
            const errorResponse = error.response;
            //Inicializo
            let errorData = {
                data: null,
                message: es.ERRORS.SERVER_CONN
            };
            //Verifico si hay error
            if(errorResponse){
                errorData = errorResponse.data;
            }
            //Oculto espera
            setLoading(false);
            //Muestro error
            alertMessages.error(errorData.message);
        }
    }
    //Render
    return (
        <SpinnerBlock active={loading}>
            <Layout
                title={ es.APP_NAME }
                subtitle={ es.PAYMENTS.ONLINE_PAYMENT }
                items={[
                    {
                        title: es.HOME,
                        link: routes.HOME
                    },
                    {
                        title: es.PAYMENTS.CHECKOUT,
                        link: routes.PAYMENT_CHECKOUT
                    },
                    {
                        title: es.PAYMENTS.ONLINE_PAYMENT,
                        active: true
                    }
                ]}
                actions={actions}
            >
                <Col xs={12}>
                    <Alert variant="info">
                        A continuación se muestra el resumen del lote que está a punto de <strong>pagar de forma online</strong>. Una vez que confirme que los datos sean correctos simplemente presione sobre el botón <FontAwesomeIcon icon={faMoneyCheck} /> <strong>PAGAR</strong> y será redireccionado a la plataforma de pagos online para finalizar el proceso.
                    </Alert>
                </Col>

                {
                    paymentData ? (
                        <OnlineForm
                            paymentData={paymentData}
                        />
                    ) : null
                }
            </Layout>
        </SpinnerBlock>
    );
};

export default CheckoutOnline;